// src/components/Education.js
import { useState } from 'react';
import { education } from '../data';
import './Education.css';

const Education = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <section id="education" className="education-section">
      <h2 onClick={() => setCollapsed(!collapsed)} className="section-header-clickable">
        Formation
        <span className="toggle-icon">{collapsed ? '▼' : '▲'}</span>
      </h2>
      {!collapsed && (
        <div className="education-list">
          {education.map((edu) => (
            <div key={edu.id} className="education-item">
              <h3>{edu.degree}</h3>
              <p className="school">{edu.school}</p>
              <p className="years">{edu.years}</p>
              {edu.description && <p className="description">{edu.description}</p>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default Education;